module.exports = __webpack_public_path__ + "static/media/photo6.66ebd44a.jpg";